export const isVehicleGroupEditable = (
  { created_by } = {},
  isSuperAdmin = false
) => {
  return isSuperAdmin || created_by !== "System";
};

export const getVehicleGroupActionError = (
  { created_by } = {},
  isSuperAdmin = false
) => {
  if (created_by === "System" && !isSuperAdmin) {
    return "System groups can't be removed or selected";
  }

  return "";
};
